<div class="screen-only feed-profit-navigation" data-test="feed-profit-navigation">
  <nav mat-tab-nav-bar color="accent" [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
    <a mat-tab-link (click)="navigate()" [active]="isIntro$ | async">
      {{ 'feed-profit.detail.navigation.intro' | translate }}
    </a>
    <a mat-tab-link (click)="navigate('quick-simulation')" [active]="isQuickSimulation$ | async">
      {{ 'feed-profit.detail.navigation.quick-simulation' | translate }}
    </a>
    <a
      mat-tab-link
      (click)="navigate('extended-simulation')"
      [active]="isExtendedSimulation$ | async"
    >
      {{ 'feed-profit.detail.navigation.extended-simulation' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
